/**
 * Northern Row Hub
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TaskStatus = 'New' | 'InProgress' | 'Complete';

export const TaskStatus = {
    New: 'New' as TaskStatus,
    InProgress: 'InProgress' as TaskStatus,
    Complete: 'Complete' as TaskStatus
};

